import { useEffect, useState } from "react";
import FlatList from 'flatlist-react';
import { formatDistance, setDefaultOptions } from 'date-fns'
import { addDoc, collection, query, where, getDocs, doc, getDoc, updateDoc, orderBy, Firestore } from "firebase/firestore";
import { db } from "../../../../../globals/firebase";
import { w2popup, w2confirm, w2alert } from 'https://cdn.jsdelivr.net/gh/vitmalina/w2ui@master/dist/w2ui.es6.min.js'
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import SectionJobsPayment from "./section-jobs-payment";
import { FiDownload } from "react-icons/fi";
import { TfiFullscreen } from "react-icons/tfi";
import { BsImages } from "react-icons/bs";
import { Runware } from "@runware/sdk-js";
import { getStorage, getDownloadURL, ref as storageRef, uploadBytesResumable } from "firebase/storage";
import { publicUser } from "../../../../../globals/route-names";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { pt } from 'date-fns/locale'
import { LazyLoadImage } from "react-lazy-load-image-component";




function SectionJobsImages(promptdoc) {
    const navigate = useNavigate();

    const [listadeimagens, setlistadeimagens] = useState([])
    const [imagesize, setimagesize] = useState("512x512")
    const [imagetotal, setimagetotal] = useState(1)
    const [user, setuser] = useState(null)
    const [usercreditsimages, setusercreditsimages] = useState(0);
    const [modalPaymentOpen, setmodalPaymentOpen] = useState(false);
    const { t, i18n } = useTranslation()


    useEffect(() => {

        setuser(JSON.parse(localStorage.getItem("user")))

        if (i18n.language == "pt-br") {
            setDefaultOptions({ locale: pt })
        }


        loadchanges()

        if (user != null && user != undefined) {
            getusercreditsimage()
        }





    }, [])

    const getusercreditsimage = async () => {

        const userData = localStorage.getItem("user");
        if (!userData) {
            console.warn("User not found in localStorage");
            return;
        }
        
        const user = JSON.parse(userData);
        if (!user.userid) {
            console.warn("User ID not found in user data");
            return;
        }

        const userid = user.userid;

        const docRef = doc(db, "wpm_users", userid)
        const userdoc = await getDoc(docRef);
        if (userdoc.data().creditsimages < 1) {
            openpayment()
            return
        }
        setusercreditsimages(userdoc.data().creditsimages)

    }



    const setcreditsimages = async (credits) => {

        const userData = localStorage.getItem("user");
        if (!userData) {
            console.warn("User not found in localStorage");
            return;
        }
        
        const user = JSON.parse(userData);
        if (!user.userid) {
            console.warn("User ID not found in user data");
            return;
        }

        const userid = user.userid;
        const docRef = doc(db, "wpm_users", userid)
        const userdoc = await getDoc(docRef);
        await updateDoc(docRef, {
            creditsimages: userdoc.data().creditsimages + credits
        });

        setusercreditsimages(userdoc.data().creditsimages + credits)
    }



    const fullscreen = (url) => {

        w2popup.open({
            modal: true,
            openMaximized: true,
            color: '#000',
            body: '<img src="' + url + '" style="height:100%;display: block;margin: auto">',
            showClose: true,
            actions: {
                Ok(event) {
                    w2popup.close()
                }
            }
        })

        //w2popup.max();

    }

    const saveAs = (url) => {
        var link = document.createElement('a');
        link.href = url;
        link.download = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    const notify = (type, wait, message) => {
        if (wait === false) {
            let color = ""

            if (type === 'error') {
                w2popup.close()
                color = 'red'
            }

            if (type == 'success') {
                color = 'green'
            }

            if (type === 'message') {
                color = 'gold'
            }

            const titlet = type === "error" ? "Error" : ""
            const title = '<span style="color:' + color + ';font-weight:bold">' + titlet + '</span'
            const messagebody = '<span style="color:' + color + '">' + message + '</span'

            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                title: title,
                body: messagebody,
                showClose: true,
                actions: {
                    Ok(event) {
                        w2popup.close()
                    }
                }
            })


        }

        if (wait === true) {
            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                text: t("general.pleasewait"),
                showClose: false,

            })


        }
    }

    const closenotify = () => {
        w2popup.close()
    }


    const openpayment = () => {
        setmodalPaymentOpen(true)
    }

    // const imageUrlToBase64 = async (url) => {
    //     const data = await fetch(url);
    //     const blob = await data.blob();
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(blob);
    //         reader.onloadend = () => {
    //             const base64data = reader.result;
    //             resolve(base64data);
    //         };
    //         reader.onerror = reject;
    //     });
    // };


    const uploadfile = async (image) => {

        return new Promise(async resolve => {
            let url = image.imageURL
            let blob = await fetch(url).then(r => r.blob());
            let file = new File([blob], "file_name.jpg", { lastModified: 1534584790000 });

            const storage = getStorage();
            const randomimagename = (Math.random() + 1).toString(36).substring(7) + ".jpg";
            const imageRef2 = storageRef(storage, user.userid + `/` + randomimagename)

            const uploadTask = uploadBytesResumable(imageRef2, file)


            uploadTask.on('state_changed',
                (snapshot) => {
                    notify("", true, t("general.pleasewait"))
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    //  console.log('Upload is ' + progress + '% done');


                    switch (snapshot.state) {
                        case 'paused':
                            //  console.log('Upload is paused');
                            break;
                        case 'running':
                            //  console.log('Upload is running');
                            break;


                    }
                },
                (error) => {
                    // Handle unsuccessful uploads
                    // alert(error.includes("supported."))
                    closenotify()
                    notify("error", false, "error: " + error.message)
                },
                async () => {

                    await getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                        console.log(promptdoc.doc)
                        const myCollection = collection(db, 'wpm_images');
                        await addDoc(myCollection, {
                            imageurl: downloadURL,
                            public: promptdoc.doc.public || false,
                            userid: promptdoc.doc.userid,
                            username: promptdoc.doc.username || "",
                            promptid: promptdoc.doc.id,
                            datainsert: Date.now()
                        }).then(() => {

                            setcreditsimages(-1, "images")
                            resolve(image)

                        })


                    })
                })
        })


    }


    const gotopromtps = () => {
        navigate(publicUser.jobs.LIST)
    }

    let createnovitaimage = async () => {

        try {

            if (promptdoc == null) {
                return
            }

            if (user == null) {


                w2alert(t('jobimages.notlogged'))
                return
            }
            else {



                const userData = localStorage.getItem("user");
                if (!userData) {
                    console.warn("User not found in localStorage");
                    return;
                }
                
                const user = JSON.parse(userData);
                if (!user.userid) {
                    console.warn("User ID not found in user data");
                    return;
                }

                const userid = user.userid;

                //console.log (userid  + "  " + promptdoc.doc.userid)
                if (userid != promptdoc.doc.userid) {

                    w2confirm(t('jobimages.createdbyother'))
                        .yes(() => {
                            navigate(publicUser.jobs.LIST)
                        })
                        .no(() => { console.log('no') })



                    return
                }


                const docRef = doc(db, "wpm_users", userid)
                const userdoc = await getDoc(docRef);
                if (userdoc.data().creditsimages < 1) {
                    openpayment()
                    return
                }

                notify("", true, t("general.pleasewait"))
                //const rndInt = Math.floor(Math.random() * 100000) + 1
                const imgsize = imagesize.split("x")


                const runware = await Runware.initialize({ apiKey: process.env.REACT_APP_RUNWARE_KEY });

                const images = await runware.requestImages(
                    {
                        "taskType": "imageInference",
                        "positivePrompt": promptdoc.doc.prompt,
                        "model": "runware:101@1",
                        "width": parseInt(imgsize[0]),
                        "height": parseInt(imgsize[1]),
                        "numberResults": imagetotal,
                        "outputFormat": "PNG",
                        "steps": 28,
                        "CFGScale": 3.5,
                        "scheduler": "FlowMatchEulerDiscreteScheduler",
                        "outputType": [
                            "URL"
                        ],
                        "includeCost": true
                    })


                const promises = [];


                images.forEach(async (image) => {

                    await uploadfile(image).then(result => {
                        // console.log(result)
                        promises.push(result);

                        closenotify()
                        loadchanges()
                    })


                })

                const promiseResponses = await Promise.all(promises)
                // console.log(promiseResponses.length)
            }
        }
        catch (error) {
            closenotify()
            notify("error", false, "error: " + error.message)

        }
        finally {
        }
    }

    const loadchanges = async () => {

        setlistadeimagens([])

        const q = query(collection(db, "wpm_images"), where("promptid", "==", promptdoc.doc.id), orderBy("datainsert", "desc"));

        const images = await getDocs(q)
        images.forEach((docu) => {

            const docinsert = {
                id: docu.id,
                imageurl: docu.data().imageurl,
                promptid: docu.data().promptid,
                dateinsert: docu.data().datainsert

            }
            setlistadeimagens(oldList => [...oldList, docinsert]);
        });
    }

    return (
        <>
            <Modal
                center
                open={modalPaymentOpen}
                onClose={() => setmodalPaymentOpen(false)}
            //onAfterOpen={afterOpenModal}
            //onRequestClose={closeModal}
            //style={customStyles}
            //contentLabel="Example Modal"
            >
                <div>
                    <SectionJobsPayment></SectionJobsPayment>
                </div>
            </Modal>



            <div className="twm-home3-banner-section twm-bnr-hpage-13">


                <div className="container">
                    <div className="row">



                        <div className="sidebarleft">
                            <span style={{ fontWeight: "bold", fontSize: "12px" }}>{t('jobimages.sizeofimages')}</span>
                            <form style={{ alignSelf: "center", paddingRight: "5px" }} className="woocommerce-ordering twm-filter-select" method="get">
                                <select onChange={(e) => { e.preventDefault(); setimagesize(e.target.value); }}>
                                    <option value="512x512">Square </option>
                                    <option value="768x1024">Portrait 3:4 </option>
                                    <option value="576x1024">Portrait 9:16 </option>
                                    <option value="1024x768">Landscape 4:3 </option>
                                    <option value="1024x576">Landscape 16:9 </option>
                                </select>
                            </form>
                            <span style={{ fontWeight: "bold", fontSize: "12px", paddingRight: "5px" }}>{t('jobimages.totalimages')}</span>

                            <input style={{ alignSelf: "center", paddingRight: "5px" }} value={imagetotal} onChange={(e) => { e.preventDefault(); setimagetotal(e.target.value); }} type="range" min="1" max="4" step="1" />
                            {imagetotal}

                            <button style={{ fontSize: "15px" }} type="submit" className="site-button" onClick={(e) => { e.preventDefault(); createnovitaimage() }}>
                                <BsImages color="white" size="15" />
                                {t('jobimages.createimages')}</button>

                            <div style={{ height: "10px" }}></div>

                        </div>


                        < div className="sidebarright twm-hpage-12-v-bnr-right-content">

                            <FlatList
                                list={listadeimagens}
                                displayGrid
                                minColumnWidth="200px"
                                scrollToTop
                                gridGap="5px"
                                renderItem={(doca, idx) =>
                                    <div key={idx} className="masonry-wrap row d-flex">
                                        {/*Block one*/}
                                        <div className="row">
                                            {/*Block one*/}
                                            <div className="col-md-12">
                                                {doca.imageurl != "" ?
                                                    <div style={{ paddingTop: "5px" }}>
                                                        <div className="card bg-light mb-3">
                                                            <div style={{ padding: "5px", borderRadius: "15px" }} className="card-body">
                                                                <LazyLoadImage src={doca.imageurl} alt="#" />
                                                            </div>



                                                            <div className="card-footer">
                                                                <span style={{ fontSize: "9px", fontWeight: "bold" }}>{(formatDistance(doca.dateinsert, Date.now(), { addSuffix: true }))}</span>

                                                                <div style={{ fontSize: "10px", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                                                    <button style={{ fontSize: "10px" }} type="submit" className="site-button" onClick={(e) => { saveAs(doca.imageurl) }}>
                                                                        <FiDownload color="white" size="15" />
                                                                        Download</button>
                                                                    <button style={{ fontSize: "10px" }} type="submit" className="site-button" onClick={(e) => { fullscreen(doca.imageurl) }}>
                                                                        <TfiFullscreen color="white" size="15" />
                                                                        {t('jobimages.fullscreen')}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>

                                                        </div>
                                                    </div>

                                                    :

                                                    ""
                                                }
                                            </div>

                                        </div>
                                    </div>


                                }
                                renderWhenEmpty={() => <div>No images for this prompt
                                    {user == null || user == undefined ?
                                        <div>
                                            <a className="site-button" data-bs-toggle="modal" href="#sign_up_popup2" role="button">
                                                <i className="feather-log-in" />
                                                Sign In to Run
                                            </a>
                                        </div>
                                        : ""}
                                </div>}
                            />

                        </div>

                    </div>
                </div>
            </div >

        </>
    )
}

export default SectionJobsImages;